export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ChangeUserTypeDialog.json?hash=2e6c20f6cba71ae17f1c3e314ae5d1ba";